import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Help = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="accounts-container">
      <header className="page-header">
        <div className="page-header-content">
          <h1 className="page-title">Help & Guide</h1>
          <p className="page-subtitle">
            Learn how to use the Family Budget Tracker for <span className="family-name">{user?.familyName}</span>
          </p>

          <nav className="page-nav">
            <button onClick={() => navigate('/home')} className="nav-btn">
              📊 Dashboard
            </button>
            <button onClick={() => navigate('/categories')} className="nav-btn">
              📂 Categories
            </button>
            <button onClick={() => navigate('/accounts')} className="nav-btn">
              🏦 Accounts
            </button>
            <button onClick={() => navigate('/help')} className="nav-btn active">
              ❓ Help
            </button>
          </nav>
        </div>
        <button onClick={logout} className="btn logout-btn">
          Logout
        </button>
      </header>

      <div className="card">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px'
        }}>
          <h2 style={{
            color: '#f0f0f0',
            margin: '0',
            fontSize: '1.8rem',
            fontWeight: '600'
          }}>
            💰 Help & Guide
          </h2>
          <div style={{
            color: '#b0b0b0',
            fontSize: '0.9rem'
          }}>
            Your complete guide to managing family finances
          </div>
        </div>

        <div style={{ color: '#e0e0e0', lineHeight: '1.6' }}>
          <div style={{
            display: 'grid',
            gap: '24px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                📊 Navigation Guide
              </h3>
              <div style={{ display: 'grid', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '1.5rem' }}>📊</span>
                  <div>
                    <strong style={{ color: '#ff6b35' }}>Dashboard:</strong> Overview of expenses, charts, and recent activity
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '1.5rem' }}>📂</span>
                  <div>
                    <strong style={{ color: '#ff6b35' }}>Categories:</strong> Create and manage spending categories with budgets
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '1.5rem' }}>🏦</span>
                  <div>
                    <strong style={{ color: '#ff6b35' }}>Accounts:</strong> Manage bank accounts and savings buckets
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '1.5rem' }}>❓</span>
                  <div>
                    <strong style={{ color: '#ff6b35' }}>Help:</strong> This page - your complete guide to using the app
                  </div>
                </div>
              </div>
            </section>

            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🚀 Getting Started
              </h3>
              <ol style={{ marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Set up Categories:</strong> Create spending categories like "Groceries," "Gas," "Entertainment"</li>
                <li style={{ marginBottom: '8px' }}><strong>Add Bank Accounts:</strong> Create your main checking and savings accounts</li>
                <li style={{ marginBottom: '8px' }}><strong>Create Savings Buckets:</strong> Set up buckets for specific financial goals</li>
                <li style={{ marginBottom: '8px' }}><strong>Start Tracking Expenses:</strong> Add your daily purchases and spending</li>
                <li style={{ marginBottom: '8px' }}><strong>Set Category Budgets:</strong> Assign monthly spending limits to each category</li>
                <li style={{ marginBottom: '0' }}><strong>Review Regularly:</strong> Check your dashboard weekly to stay on track</li>
              </ol>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '0.9rem'
              }}>
                <strong>🎯 Recommended Order:</strong> Categories → Accounts → Expenses → Budgets. This flow helps you organize before you start tracking!
              </div>
            </section>

            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                � Categoriies & Organization
              </h3>
              <ul style={{ marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Create custom categories to organize your spending (e.g., Groceries, Gas, Entertainment)</li>
                <li style={{ marginBottom: '8px' }}>Set monthly budgets for each category to track your spending goals</li>
                <li style={{ marginBottom: '8px' }}>View category-wise spending summaries and progress bars</li>
                <li style={{ marginBottom: '8px' }}>Edit or delete categories as your needs change</li>
                <li style={{ marginBottom: '0' }}>Categories help you understand where your money goes each month</li>
              </ul>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '0.9rem'
              }}>
                <strong>💡 Pro Tip:</strong> Start with broad categories like "Food," "Transportation," and "Entertainment," then get more specific as needed!
              </div>
            </section>

            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                💳 Expense Tracking
              </h3>
              <ul style={{ marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Add expenses manually with amount, category, and description</li>
                <li style={{ marginBottom: '8px' }}>Import expenses from CSV files for bulk entry</li>
                <li style={{ marginBottom: '8px' }}>View recent expenses in a sortable, filterable list</li>
                <li style={{ marginBottom: '8px' }}>Edit or delete expenses to keep your records accurate</li>
                <li style={{ marginBottom: '8px' }}>Filter expenses by date range, category, or amount</li>
                <li style={{ marginBottom: '0' }}>See visual charts showing spending patterns and category breakdowns</li>
              </ul>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '0.9rem'
              }}>
                <strong>📱 Quick Tip:</strong> Add expenses as soon as you make them - it's easier than trying to remember later!
              </div>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                padding: '12px',
                borderRadius: '8px',
                marginTop: '12px',
                fontSize: '0.9rem'
              }}>
                <strong>Don't forget:</strong> If you only plan to import, you may not add an expense manually as you might risk creating a duplicate.
              </div>
            </section>

            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                �  Dashboard Features
              </h3>
              <ul style={{ marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>View spending summaries and category breakdowns with colorful charts</li>
                <li style={{ marginBottom: '8px' }}>See recent expenses in an easy-to-read list format</li>
                <li style={{ marginBottom: '8px' }}>Track budget progress with visual progress bars for each category</li>
                <li style={{ marginBottom: '8px' }}>Filter and search expenses by date, category, or amount</li>
                <li style={{ marginBottom: '8px' }}>Quick-add new expenses without leaving the main page</li>
                <li style={{ marginBottom: '0' }}>Import expenses from CSV files for bulk data entry</li>
              </ul>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '0.9rem'
              }}>
                <strong>📈 Dashboard Tip:</strong> The pie chart shows your spending distribution - aim for balanced slices that match your priorities!
              </div>
            </section>

            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🏦 Bank Accounts
              </h3>
              <ul style={{ marginBottom: '0', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Create accounts for your checking, savings, and other bank accounts</li>
                <li style={{ marginBottom: '8px' }}>Track the total balance in each account</li>
                <li style={{ marginBottom: '8px' }}>Click the arrow (▶/▼) next to account names to expand or collapse details</li>
                <li style={{ marginBottom: '0' }}>All accounts start collapsed by default for a cleaner view</li>
              </ul>
              <br />
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🪣 Savings Buckets
              </h3>
              <ul style={{ marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Create "buckets" within each account for specific savings goals</li>
                <li style={{ marginBottom: '8px' }}>Examples: Emergency Fund, Vacation, Car Repair, Christmas Gifts</li>
                <li style={{ marginBottom: '8px' }}>Allocate portions of your account balance to different buckets</li>
                <li style={{ marginBottom: '0' }}>See how much money is "unallocated" in each account</li>
              </ul>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '0.9rem'
              }}>
                <strong>💡 Pro Tip:</strong> The unallocated amount shows money not assigned to any bucket - perfect for general spending money!
              </div>
            </section>
            {/* 
            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>

            </section> */}

            <section style={{
              background: 'rgba(255, 107, 53, 0.05)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                📨 Reach out!
              </h3>
              <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                If you have any questions,  you can always reach out directly to me.  Send me an email 
                &nbsp;<a href="mailto:info@duttonbiz.com">info@duttonbiz.com</a>
              </p>

              <ul style={{ marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Need a new template for importing your expenses?</li>
                <li style={{ marginBottom: '8px' }}>Have an idea that would be helpful to other users?</li>
                <li style={{ marginBottom: '8px' }}>Question or comment</li>
              </ul>
              <p>Let me know!</p>
            </section>

            <section style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 107, 53, 0.05))',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 107, 53, 0.3)',
              textAlign: 'center'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem'
              }}>
                💡 The Envelope Method
              </h3>
              <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                This app helps you practice the "envelope method" of budgeting, where you allocate money
                to specific purposes before you spend it. By using accounts and buckets, you're essentially
                creating digital envelopes for your money!
              </p>
            </section>

            <section style={{
              background: 'rgba(52, 152, 219, 0.1)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(52, 152, 219, 0.3)',
              textAlign: 'center'
            }}>
              <h3 style={{
                color: '#3498db',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}>
                💰 Pricing Plans & FAQs
              </h3>
              <p style={{ marginBottom: '16px', fontSize: '1.1rem', color: '#e0e0e0' }}>
                Take a look at our FAQs and learn about our pricing plans, including our free 30-day trial and affordable monthly or annual options.
              </p>
              <button
                onClick={() => window.open('/pricing', '_blank')}
                style={{
                  background: 'rgba(52, 152, 219, 0.2)',
                  border: '1px solid #3498db',
                  color: '#3498db',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(52, 152, 219, 0.3)';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(52, 152, 219, 0.2)';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                📋 View Pricing Plans & FAQs
              </button>
            </section>

            <section style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 107, 53, 0.05))',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid #ff6b35',
              textAlign: 'center'
            }}>
              <h3 style={{
                color: '#ff6b35',
                marginTop: '0',
                marginBottom: '16px',
                fontSize: '1.5rem'
              }}>
                Terms and Conditions
              </h3>
              <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                Feel free to review our terms and conditions to better understand how your data is managed.
              </p>
              <button
                onClick={() => window.open('/terms', '_blank')}
                style={{
                  background: 'rgba(255, 107, 53, 0.1)',
                  border: '1px solid #ff6b35',
                  color: '#fff',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#ff6b35';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Terms & Conditions
              </button>
            </section>

          </div>

          <div style={{
            textAlign: 'center',
            marginTop: '40px',
            padding: '24px',
            background: 'rgba(255, 107, 53, 0.05)',
            borderRadius: '12px',
            border: '1px solid rgba(255, 107, 53, 0.2)'
          }}>
            <p style={{
              margin: '0 0 16px 0',
              fontSize: '1.1rem',
              color: '#b0b0b0'
            }}>
              Ready to take control of your family's finances?
            </p>
            <button
              onClick={() => navigate('/home')}
              className="btn"
              style={{
                background: 'linear-gradient(135deg, #ff6b35, #e55a2b)',
                boxShadow: '0 2px 8px rgba(255, 107, 53, 0.3)',
                fontSize: '1.1rem',
                padding: '12px 24px'
              }}
            >
              Get Started! 🚀
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;